import { useState, ChangeEvent } from "react";
import styled from "styled-components";
import { CharityPreviewIcon, Edit, Trash } from "../../../../public/assets";
import { useNavigate } from "react-router-dom";
import {
  DeletePaymentLink,
  EditPaymentLink,
} from "../../../graphql/mutations/paymentlink";
import { useQuery, useMutation } from "@apollo/client";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { environment } from "../../../env";
import CharityProductModal from "../CharityAddModal/CharityAddProdict";
import { deleteSelectedProduct } from "../../../store/products/productSlice";
import { useDispatch } from "react-redux";

const CreateCardContainer = styled.div`
  width: 99%;
  margin: 15px 0;
  border: 1px solid #e8eaed;
  border-radius: 10px;
`;

const CreateCardInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 25px;
  width: 100%;
`;

const CreateCardImageContainer = styled.div`
  display: flex;
`;

const CreateCardImage = styled.div`
  padding-top: 15px;
  display: flex;
  margin-left: 15px;
`;

const CreateCardTitle = styled.h1`
  font-size: 14px;
  font-weight: 500;
`;

const CreateCardPrice = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #5e5e5e;
`;

const CreateCardIconsContainer = styled.div`
  img {
    padding-top: 10px;
    margin-right: 20px;
  }
`;

interface PaymentCardData {
  id: number;
  image: string;
  name: string;
  description: string;
}

interface CreatePaymentCardProps {
  data: PaymentCardData;
}

interface Charity {
  id: string;
  price: number;
  name: string;
  description: string;
  organizationId: string;
}

const CharityPaymentCard: React.FC<CreatePaymentCardProps> = ({ data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [checkedValues, setCheckedValues] = useState<string[]>([]);
  const [showBetween, setShowBetween] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editItemId, setEditItemId] = useState("");
  const [charity, setCharity] = useState<Charity[]>([]);
  const [isEdit, setIsEdit] = useState("edit");
  const [deleteProduct] = useMutation(DeletePaymentLink, {
    variables: { ...environment.paymentLinkService },
  });

  console.log({ "charity card => ": data });

  const closeModal = () => {
    setShowModal(false);
    // setEditItemId(null);
  };

  const handleEdit = (id: any) => {
    setIsEdit("edit");
    setEditItemId(id);
    setShowModal(!showModal);
  };

  const handleDelete = async (id: any) => {
    setIsDeleted(true);
    dispatch(deleteSelectedProduct(id));
  };

  return (
    <CreateCardContainer>
      <ToastContainer />
      <CreateCardInnerContainer>
        {showModal && (
          <CharityProductModal
            onClose={closeModal}
            isEdit={isEdit}
            editItemId={editItemId}
          />
        )}
        <CreateCardImageContainer>
          <div style={{ display: "flex" }}>
            <CreateCardImage>
              <img src="/assets/svg/CharityPreviewIcon.svg" alt="" />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "15px",
                  paddingTop: "20px",
                  width: "60%",
                }}
              >
                <CreateCardTitle>{data.name}</CreateCardTitle>
                <CreateCardPrice>{data.description}</CreateCardPrice>
              </div>
            </CreateCardImage>
          </div>
        </CreateCardImageContainer>
        <CreateCardIconsContainer>
          <img
            onClick={() => handleEdit(data.id)}
            src="/assets/svg/edit-2.svg"
            alt=""
            style={{ paddingRight: "10px" }}
          />
          <img
            onClick={() => handleDelete(data.id)}
            src="/assets/svg/trash.svg"
            alt=""
          />
        </CreateCardIconsContainer>
      </CreateCardInnerContainer>
    </CreateCardContainer>
  );
};

export default CharityPaymentCard;
